import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { UserDialogProvider } from './user-dialog/UserDialogContext';
import { WithUnhappyStates } from '../pages/environments/WithUnhappyStates';
import useWhenInitialFetchDone from './useWhenInitialFetchDone';
import { WebhooksProvider } from './webhooks/WebhooksContext';
import DashboardHeader from './header/DashboardHeader';
import { DASHBOARD_HEADER_HEIGHT_PX } from '../../constants';
import { useLocation } from 'react-router';
import { useSnowflakeRouteGuard } from '../../hooks/useSnowflakeRouteGuard';

interface DashboardProps {
  children?: React.ReactNode;
}

const Dashboard = ({ children }: DashboardProps) => {
  const { pathname } = useLocation();

  const mainRef = useRef<HTMLElement>(null);

  useWhenInitialFetchDone();
  useSnowflakeRouteGuard();

  useEffect(() => {
    //hack to make sure the page is scrolled to the top when the pathname changes
    if (mainRef.current) {
      mainRef.current.scrollTo(0, 0);
    }
  }, [pathname]);

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <DashboardHeader />

      <Box
        sx={{
          display: 'flex',
          height: `calc(100vh - ${DASHBOARD_HEADER_HEIGHT_PX})`,
        }}
      >
        <Box component="main" ref={mainRef} sx={{ flexGrow: 1, overflow: 'auto' }}>
          <WithUnhappyStates>{children}</WithUnhappyStates>
        </Box>
      </Box>
    </Box>
  );
};

const DashboardWithContext = (props: DashboardProps) => {
  return (
    <UserDialogProvider>
      <WebhooksProvider>
        <Dashboard {...props} />
      </WebhooksProvider>
    </UserDialogProvider>
  );
};

export { DashboardWithContext as Dashboard };
